import React, { useEffect, useState } from "react";
import { FaDollarSign, FaSave } from "react-icons/fa";
import TextFieldCustom from "../../../component/elements/textfieldCustom";
import CustomButton from "../../../component/elements/CustomButton/CustomButton";
import axiosInstance from "../../../configuration/request";
import { useSnackbar } from "../../../component/SnackbarContext";

export default function PaymentSettings({}) {
  const [delivery, setDelivery] = useState("");
  const [platform, setPlatform] = useState("");
  const [tax, setTax] = useState("");
  const showSnackbar = useSnackbar();

  useEffect(() => {
    fetchPaymentBreakdown();
  }, []);

  const fetchPaymentBreakdown = async () => {
    try {
      const res = await axiosInstance.get(
        `/customer/core?keys=plateform_fees,delivery_fees,tydii_fees (in per)`
      );
      const data = res?.data || [];
      const platformObj = data.find((item) => item.key === "plateform_fees");
      const deliveryObj = data.find((item) => item.key === "delivery_fees");
      const taxObj = data.find((item) => item.key === "tydii_fees (in per)");

      setPlatform(platformObj?.value[0] || "");
      setDelivery(deliveryObj?.value[0] || "");
      setTax(taxObj?.value[0] || "");
    } catch (error) {
      showSnackbar(
        error?.response?.data?.message || "Something went wrong!",
        "error"
      );
    }
  };

  const updatePayments = async () => {
    const payloads = [
      { key: "plateform_fees", values: [platform] },
      { key: "delivery_fees", values: [delivery] },
      { key: "tydii_fees (in per)", values: [tax] },
    ];

    try {
      await Promise.all(
        payloads.map((payload) =>
          axiosInstance.post(`/customer/core/dropdown`, payload)
        )
      );
      fetchPaymentBreakdown();
      showSnackbar("Payment settings saved successfully!", "success");
    } catch (error) {
      showSnackbar(
        error?.response?.data?.message || "Something went wrong!",
        "error"
      );
      fetchPaymentBreakdown();
    }
  };

  return (
    <div className="border rounded-lg p-6 space-y-6 w-full max-w-4xl mx-auto">
      {/* Delivery Charge */}
      <div className="flex flex-col md:flex-row md:items-center gap-5 py-3 border-b">
        <div className="min-w-[140px] font-medium text-gray-700">
          Delivery Charge
        </div>

        <TextFieldCustom
          fullWidth
          placeholder="Amount"
          value={delivery}
          onChange={(e) => setDelivery(e.target.value)}
        />
        <div className="text-sm bg-gray-100 px-4 py-2 rounded w-[300px]">
          <div className="text-gray-500 font-semibold">Type:</div>
          <div className="text-gray-800 font-bold mt-1">Fixed Amount</div>
        </div>
      </div>
      {/* Platform Charge */}
      <div className="flex flex-col md:flex-row md:items-center gap-5 py-3 border-b">
        <div className="min-w-[140px] font-medium text-gray-700">
          Platform Charge
        </div>
        <TextFieldCustom
          fullWidth
          placeholder="Amount"
          value={platform}
          onChange={(e) => setPlatform(e.target.value)}
        />
        <div className="text-sm bg-gray-100 px-4 py-2 rounded w-[300px]">
          <div className="text-gray-500 font-semibold">Type:</div>
          <div className="text-gray-800 font-bold mt-1">Fixed Amount</div>
        </div>
      </div>
      <div className="flex flex-col md:flex-row md:items-center gap-5 py-3">
        <div className="min-w-[140px] font-medium text-gray-700">
          Tax Charge
        </div>
        <TextFieldCustom
          fullWidth
          placeholder="Amount"
          value={tax}
          onChange={(e) => setTax(e.target.value)}
        />
        <div className="text-sm bg-gray-100 px-4 py-2 rounded w-[300px]">
          <div className="text-gray-500 font-semibold">Type:</div>
          <div className="text-gray-800 font-bold mt-1">Percentage Amount</div>
        </div>
      </div>
      {/* Save Button */}
      <div className="flex justify-end pt-4">
        <CustomButton
          onClick={updatePayments}
          customeClass="gradient-button w-[200px] h-[40px]"
        >
          <FaSave className="mr-1" /> Save Settings
        </CustomButton>
      </div>
    </div>
  );
}
